<template>
  <div class="wrapper">
    <div class="bg-left"></div>
    <div class="part">
      <!--手机-->
      <div class="phone">
        <div class="phone-img">
          <transition name="slide" v-for="(item,index) in imgs" :key="index">
            <img :src="item" alt=""  v-show="showIndex == index">
          </transition>

        </div>

      </div>
      <!---->
      <!--number-->
      <div class="number">02</div>
      <div class="con">
        <div class="title">为销售赋能的小名片</div>
        <div class="mark">产品展示</div>
        <ul class="list">
          <!--01-->
          <li class="item">
            <div class="icon icon1"></div>
            <div class="name">小名片展示</div>
            <div class="info">
              <div class="text">
                <p>统一公司形象，全员分享，小名片直达企业官网，产品、服务的展现</p>
              </div>
              <div class="link">
                <div class="link-item" @mouseenter="changeImage" data-index="0">名片信息</div>
                <div class="link-item" @mouseenter="changeImage" data-index="1">个人信息</div>
                <div class="link-item" @mouseenter="changeImage" data-index="2">更多信息</div>
              </div>
            </div>
          </li>
          <!--02-->
          <li class="item">
            <div class="icon icon2"></div>
            <div class="name">绑定小官网</div>
            <div class="info">
              <div class="text">
                <p>企业官网、产品、服务的完整展现</p>
                <p>帮助访客第一时间了解企业，更快促成业务交流</p>
              </div>
              <div class="link">
                <div class="link-item" @mouseenter="changeImage" data-index="3">查看名片</div>
                <div class="link-item" @mouseenter="changeImage" data-index="4">查看企业小官网</div>
                <div class="link-item" @mouseenter="changeImage" data-index="5">小官网多样式介绍</div>
              </div>
            </div>
          </li>
          <!--03-->
          <li class="item">
            <div class="icon icon3"></div>
            <div class="name">销售雷达展示</div>
            <div class="info">
              <div class="text">
                <p>访问消息实时推送，名片访客即客户，不加好友就可微信沟通不错过每个商机；探测访客访问动态，让销售沟通更高效</p>
              </div>
              <div class="link">
                <div class="link-item" @mouseenter="changeImage" data-index="6">实时推送访客消息</div>
                <div class="link-item" @mouseenter="changeImage" data-index="7">不加微信好友沟通</div>
                <div class="link-item" @mouseenter="changeImage" data-index="8">即时聊天</div>
              </div>
            </div>
          </li>
          <!--04-->
          <li class="item">
            <div class="icon icon4"></div>
            <div class="name">智能AI分析</div>
            <div class="info">
              <div class="text">
                <p>分析客户兴趣与活跃度，挖掘深度用户</p>
              </div>
              <div class="link">
                <div class="link-item" @mouseenter="changeImage" data-index="9">访客数据分析</div>
                <div class="link-item" @mouseenter="changeImage" data-index="10">访客互动情况</div>
                <div class="link-item" @mouseenter="changeImage" data-index="11">销售人员能力分析</div>
                <div class="link-item" @mouseenter="changeImage" data-index="12">销售详情分析</div>
              </div>
            </div>
          </li>
          <!--05-->
          <li class="item">
            <div class="icon icon5"></div>
            <div class="name">商机SCRM</div>
            <div class="info">
              <div class="text">
                <p>助销售进行客户标签化管理，客户跟进记录管理，客户AI分析</p>
              </div>
              <div class="link">
                <div class="link-item" @mouseenter="changeImage" data-index="13">商机标签化管理</div>
                <div class="link-item" @mouseenter="changeImage" data-index="14">销售跟进记录</div>
                <div class="link-item" @mouseenter="changeImage" data-index="15">客户访问轨迹</div>
                <div class="link-item" @mouseenter="changeImage" data-index="16">客户兴趣分析</div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>

</template>

<script type="text/ecmascript-6">
import img1 from "../../assets/images/index-phone/1-1.png"
import img2 from "../../assets/images/index-phone/1-2.png"
import img3 from "../../assets/images/index-phone/1-3.png"

import img4 from "../../assets/images/index-phone/2-1.png"
import img5 from "../../assets/images/index-phone/2-2.png"
import img6 from "../../assets/images/index-phone/2-3.png"

import img7 from "../../assets/images/index-phone/3-1.png"
import img8 from "../../assets/images/index-phone/3-2.png"
import img9 from "../../assets/images/index-phone/3-3.png"

import img10 from "../../assets/images/index-phone/4-1.png"
import img11 from "../../assets/images/index-phone/4-2.png"
import img12 from "../../assets/images/index-phone/4-3.png"
import img13 from "../../assets/images/index-phone/4-4.png"

import img14 from "../../assets/images/index-phone/5-1.png"
import img15 from "../../assets/images/index-phone/5-2.png"
import img16 from "../../assets/images/index-phone/5-3.png"
import img17 from "../../assets/images/index-phone/5-4.png"

export default {
  data() {
    return {
      phoneImgShow: true,
      imgs: [img1, img2,img3,img4,img5,img6,img7,img8,img9,img10,img11,img12,img13,img14,img15,img16,img17],
      showIndex: 0
    }
  },
  methods: {
    changeImage(e){
      let index = + (e.currentTarget.getAttribute('data-index'))
      this.showIndex = index
      /*
      setTimeout(() => {
        this.imgSrc = this.imgs[index]
        this.phoneImgShow = true
      }, 20);*/
    }
  },
  components: {

  }
}
</script>

<style scoped lang="scss">
@import '../../common/common.scss';
.wrapper{
  width: 100%;
  min-width: $min-width;
  max-width: 1200px;
  margin: 0 auto;
  height: 924px;
  position: relative;
  .bg-left{
    height: 100%;
    width: 586px;
    background-image: url('../../assets/images/index2bg.png');
    @include bg-center;
    position: absolute;
    top: 0;
    left: -420px;
  }
}
.part{
  height: 100%;
  position: absolute;
  left:0;
  top: 0;
  width: 1360px;
  @media screen and (min-width: 1050px) and (max-width: 1360px){
    width: 100%;
  }
  .phone{
    float: left;
    margin-top: 192px;
    width: 298px;
    height: 582px;
    background-image: url("../../assets/images/phone.png");
    position: relative;
    z-index: 1;
    .phone-img{
      position: absolute;
      left: 34px;
      top: 74px;
      background-color:#fff;
      height: 415px;
      width: 232px;
      overflow: hidden;
      img{
        width: 100%;
      }
    }

  }
  .number{
    font-size: 180px;
    line-height: 1.0;
    font-weight: bold;
    color: $theme-color;
    opacity: 0.1;
    position: absolute;
    left: 216px;
    top: 130px;
    @media screen and (min-width: $min-width) and (max-width: $max-width){
      left: 144px;
    }
  }
  .con{
    float: left;
    margin-top: 140px;
    margin-left: 60px;
    width: percent(1000,1360);
    @media screen and (min-width: $min-width) and (max-width: $max-width){
      margin-left: 0;
    }
    @media screen and (min-width: 1050px) and (max-width: 1150px){
      width: percent(950, 1360);
    }
    .title{
      font-size: 48px;
      color:$theme-color;
      margin-bottom: 28px;
      padding-left: 25px;
      font-weight: bold;
    }
    .mark{
      padding-left: 25px;
      font-size: 36px;
      line-height: 46px;
      color:#2cbb58;
      margin-bottom: 60px;
    }
    .list{
      @include clearfix;
      font-size: 16px;
      color: #999;
      .item{
        width: 20%;
        box-sizing: border-box;
        padding: 16px 0 46px;
        border-radius: 6px;
        float: left;
        cursor: pointer;
        /*
        @media screen and (min-width: $min-width) and (max-width: 1360px){
          width: 170px;
        }*/
        .icon{
          width: 82px;
          height: 82px;
          margin: 0 auto;
        }
        .icon1{
          background-image: url("../../assets/images/02icon1.png");
        }
        .icon2{
          background-image: url("../../assets/images/02icon2.png");
        }
        .icon3{
          background-image: url("../../assets/images/02icon3.png");
        }
        .icon4{
          background-image: url("../../assets/images/02icon4.png");
        }
        .icon5{
          background-image: url("../../assets/images/02icon5.png");
        }

        .name{
          font-size: 24px;
          text-align: center;
          margin-top: 12px;
          margin-bottom: 72px;
          color: #1e1e1e;
        }
        .text{ padding: 0 25px;}
        .text p + p{
          margin-top: 10px;
        }
        .link{
          display: none;
          position: relative;
          z-index: 1;
          .link-item {
            padding-left: 45px;
            padding-right: 45px;
            padding-top: 5px;
            padding-bottom: 5px;
            position: relative;
            color:#fff;

            & +.link-item{
              margin-top: 8px;
            }
            &::after{
              content: '';
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background-color:#fff;
              position: absolute;
              left: 25px;
              @include vertical-center;
            }
            &:hover{
              opacity: 0.8;
              background-color:rgba(255,255,255,.4);
            }
            @media screen and (min-width: 1150px) and (max-width: 1360px){
              padding-left: 35px;
              padding-right: 0;
              &::after{
                left: 20px;
              }
            }
            @media screen and (min-width: 1050px) and (max-width: 1150px){
              padding-left: 20px;
              padding-right: 20px;
              &::after{
                left: 5px;
              }
            }


          }

        }
        &:hover{
          background-color: #2cbb58;
          color:#fff;
          .link{
            display: block;
          }
          .text{
            display: none;
          }
          .name{
            color:#fff;
          }
          .icon1{
            background-image: url("../../assets/images/02icon1-active.png");
          }
          .icon2{
            background-image: url("../../assets/images/02icon2-active.png");
          }
          .icon3{
            background-image: url("../../assets/images/02icon3-active.png");
          }
          .icon4{
            background-image: url("../../assets/images/02icon4-active.png");
          }
          .icon5{
            background-image: url("../../assets/images/02icon5-active.png");
          }


        }
      }

    }
  }

}
.slide-enter-active{
  transition: all 0.4s;
}
.slide-enter,.slide-leave-to{
  opacity: 0;
  transform: translate(100%, 0);
}
</style>



// WEBPACK FOOTER //
// src/apps/zcx/components/business/IndexPartTwo.vue